'use strict';

define('lib/analytics/config',[
  './config.prod',
  './config.local',
  'lib/getParameterByName'
], function (
  configProd,
  configLocal,
  getParamByName
) {
  var __local = ['localhost', '192']; // yes, I am 192 (Bill) on local network. You're welcome
  var __dlParams = getParamByName('datalayerdebug');

  // this is the best I could come up with to prevent this local config from going to prod
  // do not let the debugger config go to prod
  function __environConfig() {
    var subdomain = window.location.hostname.split('.').shift();

    if (__dlParams) {
      return configLocal(__dlParams);
    }

    if (__local.indexOf(subdomain) > -1) {
      return configLocal();
    }

    return configProd;
  }

  return __environConfig();
});

